module.exports = __webpack_public_path__ + "img/绿城中国.87dea0a8.png";